module.exports = __webpack_public_path__ + "static/media/Childish Gambino - Feels Like Summer (1).4c69453b.mp3";